import React, { FC, useEffect, useState } from 'react';
import { Button, Checkbox, CheckboxProps, Tag } from 'antd';
import { TDivisionResponse, TOrganizationResponse } from 'app/services/edpApiV1/moderator';
import { TAddUserEmployee } from 'shared/types/news.types';
import ModalAddUsers from '../modalAddUsers/ModalAddUsers';
import style from './index.module.scss';

type TProps = {
  selectedUsers?: TAddUserEmployee[];
  changeUsers: (users: TAddUserEmployee[]) => void;
  selectedDivisions?: TDivisionResponse[];
  addDivisions: (users: TDivisionResponse[]) => void;
  selectedOrganizations?: TOrganizationResponse[];
  addOrganizations: (users: TOrganizationResponse[]) => void;
};

const PickUsers: FC<TProps> = ({
  selectedUsers,
  changeUsers,
  selectedDivisions,
  addDivisions,
  addOrganizations,
  selectedOrganizations,
}) => {
  const [addUserModalOpen, setAddUserModalOpen] = useState<boolean>(false);
  const [isForAllEmployees, setIsForAllEmployees] = useState<boolean>(true);

  useEffect(() => {
    setIsForAllEmployees(!(selectedUsers?.length || selectedDivisions?.length || selectedOrganizations?.length));
  }, [selectedUsers, selectedDivisions, selectedOrganizations]);

  useEffect(() => {
    if (isForAllEmployees) {
      changeUsers([]);
      addDivisions([]);
      addOrganizations([]);
    }
  }, [isForAllEmployees]);

  const onAllUsersToggled: CheckboxProps['onChange'] = e => {
    setIsForAllEmployees(e.target.checked);
  };

  const handleSubmitAddUsersModal = (users: TAddUserEmployee[]) => {
    setIsForAllEmployees(!(selectedUsers?.length || selectedDivisions?.length || selectedOrganizations?.length));
    setAddUserModalOpen(false);
    changeUsers(users);
  };

  const handleCloseAddUsersModal = () => {
    setAddUserModalOpen(false);
  };
  const openModal = () => {
    setAddUserModalOpen(true);
  };

  const deleteEmployeeTag = (id: number) => {
    if (selectedUsers) {
      const newTags = selectedUsers.filter(tag => tag.id !== id);
      changeUsers(newTags);
    }
  };

  const deleteDivisionTag = (id: string) => {
    if (selectedDivisions) {
      const newTags = selectedDivisions.filter(tag => tag.id !== id);
      addDivisions(newTags);
    }
  };

  const deleteOrganizationTag = (id: string) => {
    if (selectedOrganizations) {
      const newTags = selectedOrganizations.filter(tag => tag.id !== id);
      addOrganizations(newTags);
    }
  };

  return (
    <div className={style['pick-users']}>
      <div className={style['pick-users__top']}>
        <Checkbox checked={isForAllEmployees} onChange={onAllUsersToggled}>
          Всем сотрудникам
        </Checkbox>
        <Button type="primary" onClick={openModal} disabled={isForAllEmployees}>
          Добавить
        </Button>
      </div>
      {!isForAllEmployees ? (
        <div className={style['pick-users__bottom']}>
          <div className={style.tags}>
            {selectedUsers?.map(tag => (
              <Tag
                closable
                onClose={() => deleteEmployeeTag(tag.id)}
                key={tag.id}
                style={{ borderRadius: '10px', marginBottom: '5px' }}
              >
                {tag.fio}
              </Tag>
            ))}
            {selectedDivisions?.map(tag => (
              <Tag
                closable
                onClose={() => deleteDivisionTag(tag.id)}
                key={tag.id}
                style={{ borderRadius: '10px', marginBottom: '5px' }}
              >
                {tag.name}
              </Tag>
            ))}
            {selectedOrganizations?.map(tag => (
              <Tag
                closable
                onClose={() => deleteOrganizationTag(tag.id)}
                key={tag.id}
                style={{ borderRadius: '10px', marginBottom: '5px' }}
              >
                {tag.name}
              </Tag>
            ))}
          </div>
        </div>
      ) : null}
      <ModalAddUsers
        selectedUsers={selectedUsers}
        open={addUserModalOpen}
        onOk={handleSubmitAddUsersModal}
        onCancel={handleCloseAddUsersModal}
        addUsers={changeUsers}
        addDivisions={addDivisions}
        selectedDivisions={selectedDivisions}
        addOrganizations={addOrganizations}
        selectedOrganizations={selectedOrganizations}
      />
    </div>
  );
};

export default PickUsers;
